import { DESTINATION_INTEGRATION_TYPES } from "@whatslly/types/messages-server/destinations";
import type { DestinationListEntry } from "./DestinationsListTypes";

export const SecurityPlaceholderForm = () => null;

// Single source of truth for the SECURITY destinations. Kept in a dependency-light module (no modal
// forms / stores) so it can be consumed both by DestinationList and by the CreateNewOrg modal without
// pulling the full destinations graph — which would create a circular dependency.
export const securityDestinations: DestinationListEntry[] = [
  {
    id: "palo-alto-firewall",
    name: "Palo Alto",
    category: "Firewall",
    form: SecurityPlaceholderForm,
    type: "paloAltoFirewall",
    img: "https://assets.whatslly.com/product/img/logos/destination-palo-alto-firewall.png",
    className: "paloAlto-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.SECURITY,
  },
  {
    id: "checkpoint-firewall",
    name: "Check Point",
    category: "Firewall",
    form: SecurityPlaceholderForm,
    type: "checkpointFirewall",
    img: "https://assets.whatslly.com/product/img/logos/destination-checkpoint.svg",
    className: "checkpoint-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.SECURITY,
  },
  {
    id: "sentinel-one-firewall",
    name: "Sentinel One",
    category: "Endpoint protection",
    form: SecurityPlaceholderForm,
    type: "sentinelOneFirewall",
    img: "https://assets.whatslly.com/product/img/logos/destination-sentinel-one-firewall.png",
    className: "sentinelOne-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.SECURITY,
  },
  {
    id: "skyhigh-proxy",
    name: "Skyhigh",
    category: "Proxy",
    form: SecurityPlaceholderForm,
    type: "skyhighProxy",
    img: "https://assets.whatslly.com/product/img/logos/destination-skyhigh.png",
    className: "skyhigh-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.SECURITY,
  },
  {
    id: "netskope-casb-proxy",
    name: "Netskope (CASB)",
    category: "Proxy",
    form: SecurityPlaceholderForm,
    type: "netskopeCasbProxy",
    img: "https://assets.whatslly.com/product/img/logos/destination-netskope.webp",
    className: "netskope-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.SECURITY,
  },
  {
    id: "crowdstrike-endpoint-protection",
    name: "CrowdStrike",
    category: "Endpoint protection",
    form: SecurityPlaceholderForm,
    type: "crowdStrikeEndpointProtection",
    img: "https://assets.whatslly.com/product/img/logos/destination-crowdstrike.png",
    className: "crowdstrikeSecurity-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.SECURITY,
  },
  {
    id: "broadcom-proxysg-proxy",
    name: "Broadcom (Symantec ProxySG)",
    category: "Proxy",
    form: SecurityPlaceholderForm,
    type: "broadcomProxySg",
    img: "https://assets.whatslly.com/product/img/logos/destination-broadcom.png",
    className: "broadcom-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.SECURITY,
  },
  {
    id: "forcepoint-proxy-websecurity",
    name: "Forcepoint (Proxy WebSecurity)",
    category: "Firewall",
    form: SecurityPlaceholderForm,
    type: "forcepointProxyWebSecurity",
    img: "https://assets.whatslly.com/product/img/logos/destination-forcepoint.png",
    className: "forcepointSecurity-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.SECURITY,
  },
  {
    id: "fortinet-fortigate-proxy",
    name: "Fortinet (Fortigate)",
    category: "Firewall",
    form: SecurityPlaceholderForm,
    type: "fortinetFortigateProxy",
    img: "https://assets.whatslly.com/product/img/logos/destination-fortinet.webp",
    className: "fortinet-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.SECURITY,
  },
  {
    id: "trellix-proxy",
    name: "Trellix",
    category: "Endpoint protection",
    form: SecurityPlaceholderForm,
    type: "trellixProxy",
    img: "https://assets.whatslly.com/product/img/logos/destination-trellix.png",
    className: "trellix-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.SECURITY,
  },
  {
    id: "trend-micro-ee-endpoint-protection",
    name: "Trend Micro (Ee)",
    category: "Endpoint protection",
    form: SecurityPlaceholderForm,
    type: "trendMicroEeEndpointProtection",
    img: "https://assets.whatslly.com/product/img/logos/destination-trend-micro.png",
    className: "trendMicro-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.SECURITY,
  },
  {
    id: "kaspersky-endpoint",
    name: "Kaspersky",
    category: "Endpoint",
    form: SecurityPlaceholderForm,
    type: "kasperskyEndpoint",
    img: "https://assets.whatslly.com/product/img/logos/destination-kaspersky.png",
    className: "kaspersky-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.SECURITY,
  },
  {
    id: "other",
    name: "Select Other Security Stack",
    category: "Other",
    form: SecurityPlaceholderForm,
    type: "other",
    img: "https://assets.whatslly.com/product/img/logos/destination-other.jpeg",
    className: "other-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.SECURITY,
  },
  {
    id: "zscaler-proxy",
    name: "Zscaler",
    category: "Proxy",
    form: SecurityPlaceholderForm,
    type: "zscalerProxy",
    img: "https://assets.whatslly.com/product/img/logos/destination-zscaler.png",
    className: "zscaler-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.SECURITY,
  },
  {
    id: "sonicwall-firewall",
    name: "SonicWall",
    category: "Firewall",
    form: SecurityPlaceholderForm,
    type: "sonicWallFirewall",
    img: "https://assets.whatslly.com/product/img/logos/destination-sonicwall.png",
    className: "sonicwall-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.SECURITY,
  },
  {
    id: "cisco-firewall",
    name: "Cisco",
    category: "Firewall",
    form: SecurityPlaceholderForm,
    type: "ciscoFirewall",
    img: "https://assets.whatslly.com/product/img/logos/destination-cisco.png",
    className: "cisco-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.SECURITY,
  },
  {
    id: "microsoft-defender-endpoint",
    name: "Microsoft Defender",
    category: "Endpoint",
    form: SecurityPlaceholderForm,
    type: "microsoftDefenderEndpoint",
    img: "https://assets.whatslly.com/product/img/logos/destination-microsoft-defender.png",
    className: "microsoftDefender-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.SECURITY,
  },
  {
    id: "carbon-black-endpoint",
    name: "Carbon Black",
    category: "Endpoint",
    form: SecurityPlaceholderForm,
    type: "carbonBlackEndpoint",
    img: "https://assets.whatslly.com/product/img/logos/destination-carbon-black.png",
    className: "carbonBlack-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.SECURITY,
  },
  {
    id: "sophos-firewall",
    name: "Sophos",
    category: "Firewall",
    form: SecurityPlaceholderForm,
    type: "sophosFirewall",
    img: "https://assets.whatslly.com/product/img/logos/destination-sophos.png",
    className: "sophos-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.SECURITY,
  },
];
